import { render, staticRenderFns } from "./AccountantItem.vue?vue&type=template&id=288ff9f2"
import script from "./AccountantItem.vue?vue&type=script&lang=js"
export * from "./AccountantItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports